import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_11 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_12 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_15 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_16 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_17 = { class: "float-end" };
const _hoisted_18 = { class: "float-end hidden-xs record-count" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12" };
const _hoisted_20 = { class: "card bg-white data-grid events-grid detached overflow-x-auto" };
const _hoisted_21 = {
    id: "eventsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_22 = { class: "max-width300" };
const _hoisted_23 = { class: "hidden-sm" };
const _hoisted_24 = { class: "hidden-sm" };
const _hoisted_25 = { class: "hidden-sm" };
const _hoisted_26 = { class: "hidden-sm" };
const _hoisted_27 = { class: "hidden-sm" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = { class: "hidden-sm" };
const _hoisted_30 = { class: "clearfix visible-sm" };
const _hoisted_31 = { class: "blue lead" };
const _hoisted_32 = { class: "clearfix" };
const _hoisted_33 = { class: "clearfix" };
const _hoisted_34 = { class: "hidden-sm" };
const _hoisted_35 = { class: "hidden-sm" };
const _hoisted_36 = { class: "hidden-sm" };
const _hoisted_37 = { class: "hidden-sm" };
const _hoisted_38 = { class: "hidden-sm" };
const _hoisted_39 = { key: 0 };
const _hoisted_40 = { class: "clearfix" };
const _hoisted_41 = { class: "x_panel" };
const _hoisted_42 = { class: "x_content" };
const _hoisted_43 = { class: "d-block" };
const _hoisted_44 = { class: "float-end" };
const _hoisted_45 = { id: "current" };
const _hoisted_46 = { id: "maximum" };
const _hoisted_47 = { class: "clearfix card" };
const _hoisted_48 = { class: "clearfix card-header" };
const _hoisted_49 = { class: "d-flex float-start" };
const _hoisted_50 = { style: { "margin-top": "2px" } };
const _hoisted_51 = { class: "float-end" };
const _hoisted_52 = {
    key: 0,
    class: "clearfix card-body p-0"
};
const _hoisted_53 = { class: "card bg-white data-grid event-alarms-grid overflow-x-auto m-0" };
const _hoisted_54 = { class: "table table-hover bottom0 border-collapse-separate" };
const _hoisted_55 = { class: "text-end" };
const _hoisted_56 = { key: 0 };
const _hoisted_57 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[78] || (_cache[78] = _createElementVNode("div", { class: "form-details" }, [
            _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tEvents\r\n\t\t\t\t")
            ])
        ], -1 /* CACHED */)),
        _cache[79] || (_cache[79] = _createTextVNode()),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.selectedCompanyId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                            options: _ctx.companies,
                            "track-by": "value",
                            label: "text",
                            showLabels: false,
                            placeholder: "All companies",
                            class: "multiselect-small"
                        }, {
                            noResult: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                ]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.siteId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.siteId) = $event)),
                            options: _ctx.sitesFiltered,
                            "track-by": "value",
                            label: "text",
                            showLabels: false,
                            placeholder: "All sites",
                            class: "multiselect-small"
                        }, {
                            noResult: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                ]),
                _cache[21] || (_cache[21] = _createTextVNode()),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.selectedSystemId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.selectedSystemId) = $event)),
                            options: _ctx.systemsFiltered,
                            "track-by": "systemId",
                            label: "displayName",
                            showLabels: false,
                            placeholder: "All systems",
                            class: "multiselect-small"
                        }, {
                            noResult: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                ]),
                _cache[22] || (_cache[22] = _createTextVNode()),
                _createElementVNode("div", _hoisted_10, [
                    (!_ctx.showDatePickers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                return (_openBlock(), _createBlock(_component_b_button, {
                                    class: "pw100",
                                    disabled: _ctx.working,
                                    key: idx,
                                    variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                    onClick: ($event) => (_ctx.setDateFilterOption(item))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[19] || (_cache[19] = _createTextVNode()),
                    (_ctx.showDatePickers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_b_input_group, {
                                    class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_flat_pickr, {
                                            class: "form-control",
                                            modelValue: _ctx.query.startTime,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.startTime) = $event)),
                                            config: _ctx.datePickerConfig,
                                            placeholder: "From date",
                                            disabled: _ctx.working
                                        }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                        _cache[14] || (_cache[14] = _createTextVNode()),
                                        _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                    _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "btn btn-default",
                                                            "data-toggle": ""
                                                        }, [
                                                            _createElementVNode("i", { class: "fa fa-calendar" })
                                                        ])
                                                    ], -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                            ]),
                            _cache[18] || (_cache[18] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_b_input_group, {
                                    class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_flat_pickr, {
                                            class: "form-control",
                                            modelValue: _ctx.query.endTime,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.endTime) = $event)),
                                            config: _ctx.datePickerConfig,
                                            placeholder: "Until date",
                                            disabled: _ctx.working
                                        }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                        _cache[17] || (_cache[17] = _createTextVNode()),
                                        _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                            default: _withCtx(() => [
                                                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-default",
                                                        "data-toggle": ""
                                                    }, [
                                                        _createElementVNode("i", { class: "fa fa-calendar" })
                                                    ])
                                                ], -1 /* CACHED */)),
                                                _cache[16] || (_cache[16] = _createTextVNode()),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn-secondary",
                                                    onClick: _cache[5] || (_cache[5] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                }, "\r\n\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ]),
            _cache[42] || (_cache[42] = _createTextVNode()),
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "clearfix" }, null, -1 /* CACHED */)),
            _cache[44] || (_cache[44] = _createTextVNode()),
            (_ctx.searchAttempted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_b_pagination, {
                                class: "float-end",
                                modelValue: _ctx.query.pageNo,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.query.pageNo) = $event)),
                                "per-page": _ctx.query.pageSize,
                                "total-rows": _ctx.data.recordCount,
                                "hide-ellipsis": true,
                                disabled: _ctx.working
                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                        ]),
                        _cache[23] || (_cache[23] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_18, "\r\n\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true),
            _cache[45] || (_cache[45] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("table", _hoisted_21, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_22, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'whenFirstAlarmRaised', title: 'First Alarm', visible: true }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _cache[24] || (_cache[24] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_23, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'whenLastAlarmRaised', title: 'Last Alarm', visible: true }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _cache[25] || (_cache[25] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_24, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'systemName', title: 'System' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _cache[26] || (_cache[26] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_25, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'eventTypeName', title: 'Event Type' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _cache[27] || (_cache[27] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_26, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'status', title: 'Status' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _cache[28] || (_cache[28] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_27, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'siteName', title: 'Site' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ])
                            ])
                        ]),
                        _cache[40] || (_cache[40] = _createTextVNode()),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    class: "pointer",
                                    onClick: ($event) => (_ctx.view(item))
                                }, [
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formatDateTime(item.whenFirstAlarmRaised)), 1 /* TEXT */),
                                        _cache[33] || (_cache[33] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_30, [
                                            _createElementVNode("span", _hoisted_31, _toDisplayString(item.eventTypeName), 1 /* TEXT */),
                                            _cache[31] || (_cache[31] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_32, [
                                                _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(item.whenCreated)), 1 /* TEXT */)
                                            ]),
                                            _cache[32] || (_cache[32] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_33, [
                                                _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1 /* CACHED */)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.getEventStatusDescription(item)), 1 /* TEXT */)
                                            ])
                                        ])
                                    ]),
                                    _cache[34] || (_cache[34] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.formatDateTime(item.whenLastAlarmRaised)), 1 /* TEXT */),
                                    _cache[35] || (_cache[35] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_35, _toDisplayString(item.systemName), 1 /* TEXT */),
                                    _cache[36] || (_cache[36] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_36, _toDisplayString(item.eventTypeName), 1 /* TEXT */),
                                    _cache[37] || (_cache[37] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.getEventStatusDescription(item)), 1 /* TEXT */),
                                    _cache[38] || (_cache[38] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_38, _toDisplayString(item.siteName), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_28));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _cache[41] || (_cache[41] = _createTextVNode()),
                        _createElementVNode("tfoot", null, [
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [...(_cache[39] || (_cache[39] = [
                                        _createElementVNode("td", {
                                            class: "text-center hidden-sm",
                                            colspan: "8"
                                        }, [
                                            _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
                                        ], -1 /* CACHED */),
                                        _createTextVNode(),
                                        _createElementVNode("td", { class: "text-center visible-sm" }, [
                                            _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
                                        ], -1 /* CACHED */)
                                    ]))]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.searchAttempted]
            ])
        ]),
        _cache[80] || (_cache[80] = _createTextVNode()),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "event_popup",
            modelValue: _ctx.showEventPopUp,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.showEventPopUp) = $event)),
            "header-bg-variant": "normal",
            size: "xl"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tEvent " + _toDisplayString(_ctx.eventModel.eventTypeName) + ": " + _toDisplayString(_ctx.getEventStatusDescription(_ctx.eventModel)), 1 /* TEXT */)
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save
                    }, {
                        default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createTextVNode(" Save\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _cache[75] || (_cache[75] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createTextVNode(" Cancel\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _cache[76] || (_cache[76] = _createTextVNode()),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h2", null, "System: " + _toDisplayString(_ctx.eventModel.systemName), 1 /* TEXT */)
                                    ]),
                                    _cache[57] || (_cache[57] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("div", null, [
                                            _cache[46] || (_cache[46] = _createElementVNode("label", null, "First Alarm raised on:", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.eventModel.whenEventStarted)) + " ", 1 /* TEXT */),
                                            _cache[47] || (_cache[47] = _createElementVNode("label", null, " | Last Alarm raised on: ", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.eventModel.whenLastAlarmRaised)), 1 /* TEXT */)
                                        ]),
                                        _cache[51] || (_cache[51] = _createTextVNode()),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("label", null, [
                                                _createTextVNode("Event Duration: " + _toDisplayString(_ctx.eventModel.durationText) + " ", 1 /* TEXT */),
                                                _cache[48] || (_cache[48] = _createElementVNode("i", {
                                                    class: "fa fa-question-circle-o",
                                                    "aria-hidden": "true",
                                                    title: "Total duration since the initial alarm was raised, to when the final alarm was raised. In addition to the designated time window."
                                                }, null, -1 /* CACHED */))
                                            ])
                                        ]),
                                        _cache[52] || (_cache[52] = _createTextVNode()),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("label", null, [
                                                _createTextVNode("Alarms Duration: " + _toDisplayString(_ctx.eventModel.alarmsDurationText) + " ", 1 /* TEXT */),
                                                _cache[49] || (_cache[49] = _createElementVNode("i", {
                                                    class: "fa fa-question-circle-o",
                                                    "aria-hidden": "true",
                                                    title: "Total duration since the initial alarm was raised, to the clearing of the final alarm."
                                                }, null, -1 /* CACHED */))
                                            ])
                                        ]),
                                        _cache[53] || (_cache[53] = _createTextVNode()),
                                        _cache[54] || (_cache[54] = _createElementVNode("label", null, "Notes", -1 /* CACHED */)),
                                        _cache[55] || (_cache[55] = _createTextVNode()),
                                        _createVNode(_component_b_form_textarea, {
                                            name: "notes",
                                            modelValue: _ctx.eventModel.notes,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.eventModel.notes) = $event)),
                                            rows: "5",
                                            maxlength: _ctx.maxCommentLength
                                        }, null, 8 /* PROPS */, ["modelValue", "maxlength"]),
                                        _cache[56] || (_cache[56] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_44, [
                                            _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.getCommentLength), 1 /* TEXT */),
                                            _cache[50] || (_cache[50] = _createTextVNode()),
                                            _createElementVNode("span", _hoisted_46, "/ " + _toDisplayString(_ctx.maxCommentLength), 1 /* TEXT */)
                                        ])
                                    ])
                                ])
                            ]),
                            _cache[72] || (_cache[72] = _createTextVNode()),
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("div", _hoisted_49, [
                                            _cache[60] || (_cache[60] = _createElementVNode("h2", { class: "m-0 me-3" }, "Alarms", -1 /* CACHED */)),
                                            _cache[61] || (_cache[61] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_50, [
                                                _cache[58] || (_cache[58] = _createElementVNode("label", { class: "m-0" }, "Active: ", -1 /* CACHED */)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.getActiveAlarmsCount()) + " |\r\n\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                _cache[59] || (_cache[59] = _createElementVNode("label", { class: "m-0" }, " Total: ", -1 /* CACHED */)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.getTotalAlarmsCount()), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _cache[62] || (_cache[62] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("a", {
                                                class: "collapse-link",
                                                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.alarmDetailsVisible = !_ctx.alarmDetailsVisible))
                                            }, [
                                                _createElementVNode("i", {
                                                    class: _normalizeClass(_ctx.alarmDetailsVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down')
                                                }, null, 2 /* CLASS */)
                                            ])
                                        ])
                                    ]),
                                    _cache[71] || (_cache[71] = _createTextVNode()),
                                    _createVNode(_Transition, { name: "slide" }, {
                                        default: _withCtx(() => [
                                            (_ctx.alarmDetailsVisible)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                    _createElementVNode("div", _hoisted_53, [
                                                        _createElementVNode("table", _hoisted_54, [
                                                            _cache[68] || (_cache[68] = _createElementVNode("thead", null, [
                                                                _createElementVNode("tr", null, [
                                                                    _createElementVNode("th", { class: "alarm-border" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tTime\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tLocation\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tDescription\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tState\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("th", { class: "text-end" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tValue\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ])
                                                            ], -1 /* CACHED */)),
                                                            _cache[69] || (_cache[69] = _createTextVNode()),
                                                            _createElementVNode("tbody", null, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventModel.alarms, (item) => {
                                                                    return (_openBlock(), _createElementBlock("tr", {
                                                                        class: _normalizeClass(['alarm', _ctx.alarmClass(item)])
                                                                    }, [
                                                                        _createElementVNode("td", null, [
                                                                            _createVNode(_component_router_link, {
                                                                                to: { name: 'alarms', query: { 'alarmId': item.alarmId } },
                                                                                class: "blue"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.formatDateTime(item.whenRaised)), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                                                        ]),
                                                                        _cache[63] || (_cache[63] = _createTextVNode()),
                                                                        _createElementVNode("td", null, _toDisplayString(item.componentName), 1 /* TEXT */),
                                                                        _cache[64] || (_cache[64] = _createTextVNode()),
                                                                        _createElementVNode("td", null, _toDisplayString(item.alarmDefinitionName), 1 /* TEXT */),
                                                                        _cache[65] || (_cache[65] = _createTextVNode()),
                                                                        _createElementVNode("td", null, _toDisplayString(_ctx.getAlarmState(item)), 1 /* TEXT */),
                                                                        _cache[66] || (_cache[66] = _createTextVNode()),
                                                                        _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.getAlarmValue(item)), 1 /* TEXT */)
                                                                    ], 2 /* CLASS */));
                                                                }), 256 /* UNKEYED_FRAGMENT */))
                                                            ]),
                                                            _cache[70] || (_cache[70] = _createTextVNode()),
                                                            (!_ctx.eventModel.alarms || !_ctx.eventModel.alarms.length)
                                                                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_56, [...(_cache[67] || (_cache[67] = [
                                                                        _createElementVNode("tr", null, [
                                                                            _createElementVNode("td", {
                                                                                colspan: "5",
                                                                                class: "text-center"
                                                                            }, [
                                                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no alarms at this time.\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                            ])
                                                                        ], -1 /* CACHED */)
                                                                    ]))]))
                                                                : _createCommentVNode("v-if", true)
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[77] || (_cache[77] = _createTextVNode())
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _cache[81] || (_cache[81] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
